import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { FaChalkboardTeacher, FaUtensils } from 'react-icons/fa';
import { FiMonitor } from 'react-icons/fi';
import { AiOutlineShoppingCart, AiOutlineIdcard } from 'react-icons/ai';
import 'react-toastify/dist/ReactToastify.css';
import OrgContext from '../context/OrgContext';

const Operations = () => {
    const { user } = useContext(OrgContext);
    const locations = user?.locationIDs || [];

    const [activeLocation, setActiveLocation] = useState(null);

    // Set the initial active location to the first location in the list
    useEffect(() => {
        if (locations.length > 0 && !activeLocation) {
            setActiveLocation(locations[0]); // Set to first location on load
        }
    }, [locations, activeLocation]);

    // Handle location change by user selection
    const handleLocationChange = (event) => {
        const selectedLocationId = event.target.value;
        const selectedLocation = locations.find((location) => location._id === selectedLocationId);
        setActiveLocation(selectedLocation);
    };

    return (
        <div className="flex flex-col items-center justify-center h-screen bg-gray-900">
            {/* Location Dropdown (only if there are multiple locations) */}
            {locations.length > 1 && (
                <select
                    value={activeLocation?._id || ''}
                    onChange={handleLocationChange}
                    className="mb-4 px-4 py-2 bg-gray-800 text-white rounded"
                >
                    {locations.map(location => (
                        <option key={location._id} value={location._id}>
                            {location.name}
                        </option>
                    ))}
                </select>
            )}

            {/* Main Action Buttons */}
            <div className="grid grid-cols-2 gap-6 w-full max-w-md px-4">
                {/* First row: ID card and Attendance */}
                <Link
                    to="/idqr"
                    className="text-white flex flex-col items-center justify-center bg-indigo-600 rounded-full w-40 h-40 hover:bg-indigo-700 transition duration-300"
                >
                    <AiOutlineIdcard className="text-6xl" />
                    <span className="mt-4 text-lg">ID Card</span>
                </Link>
                <Link to={`/attendance?locationID=${activeLocation?._id}`}
                        className="text-white flex flex-col items-center justify-center bg-blue-600 rounded-full w-40 h-40 hover:bg-blue-700 transition duration-300"
                >
                    <FaChalkboardTeacher className="text-6xl" />
                    <span className="mt-4 text-lg">Attendance</span>
                </Link>

                {/* Second row: Kitchen and Display */}
                {activeLocation && (
                    <>
                        <Link to={`/kitchen?locationID=${activeLocation._id}`}
                            className="text-white flex flex-col items-center justify-center bg-red-600 rounded-full w-40 h-40 hover:bg-red-700 transition duration-300"
                        >
                            <FaUtensils className="text-6xl" />
                            <span className="mt-4 text-lg">Kitchen</span>
                        </Link>
                        <Link
                            to={`/display?locationID=${activeLocation._id}`}
                            className="text-white flex flex-col items-center justify-center bg-green-600 rounded-full w-40 h-40 hover:bg-green-700 transition duration-300"
                        >
                            <FiMonitor className="text-6xl" />
                            <span className="mt-4 text-lg">Display</span>
                        </Link>
                    </>
                )}

                {/* Third row: Dynamic POS Terminals based on location data */}
                {activeLocation?.terminals && Array.from({ length: activeLocation.terminals }).map((_, index) => (
                    <Link
                        to={`/POS?p=${activeLocation._id}&t=${index + 1}`}
                        key={index}
                        className="text-white flex flex-col items-center justify-center bg-yellow-600 rounded-full w-40 h-40 hover:bg-yellow-700 transition duration-300"
                    >
                        <AiOutlineShoppingCart className="text-6xl" />
                        <span className="mt-4 text-lg">POS #{index + 1}</span>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default Operations;
